(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceTimeSessionServantDeleteController', ServiceTimeSessionServantDeleteController);

    ServiceTimeSessionServantDeleteController.$inject = ['$uibModalInstance', 'entity', 'ServiceTimeSessionServant'];

    function ServiceTimeSessionServantDeleteController($uibModalInstance, entity, ServiceTimeSessionServant) {
        var vm = this;

        vm.serviceTimeSessionServant = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ServiceTimeSessionServant.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
